// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0bbead36","453":"d0038dfe","667":"8b923cb2","977":"9362a5fc"}[chunkId] + ".chunk.js";
};